export default __webpack_public_path__ + "b159420ae8adfea4c7e3a7673fc4383f.png";